module.exports = "https://www.gc-qa.gnp.com.mx/1e14e53ae09688b4ec99500d9055b2f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Stepper2@2x.svg
// module id = 933
// module chunks = 0